import { SkyText } from "@skypointcloud/skypoint-ui";
import type { ComponentProps } from "react";
import { ReauthDialog } from "@/components/settings/ReauthDialog";
import type { TestReauth } from "@/hooks/use-destination-test-run";

/** The re-authentication dialog of a Test or Check now. */
export function TestReauthDialog({
  testReauth,
  isRetrying,
  remember,
  onConfirm,
  onCancel,
}: {
  testReauth: TestReauth | null;
  isRetrying: boolean;
  remember: ComponentProps<typeof ReauthDialog>["remember"];
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <ReauthDialog
      open={testReauth !== null}
      isRetrying={isRetrying}
      changeSummary={
        <SkyText size={200}>
          {testReauth?.mode === "check"
            ? "Check now: skyData signs in to the destination with the saved settings."
            : "Test: skyData signs in to the destination with the saved settings."}
        </SkyText>
      }
      error={testReauth?.error ?? null}
      code={testReauth?.code ?? "REAUTH_REQUIRED"}
      blocked={false}
      remember={remember}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
